import { ComponentType, useEffect, useState, useCallback } from 'react'
import { Navigate } from 'react-router-dom'

import { Box, CircularProgress } from '@mui/material'

import { securityApi } from 'services/security'
import { useRequest } from 'hooks/useRequest'
import { initialConfigApi } from 'services/initialConfig'
import { NetworkDownNoMessageResponse } from 'common/types/security'

interface Props {
  component: ComponentType<any>
}

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
const PrivateRoute = ({ component: Component }: Props) => {
  const [loggedIn, setLoggedIn] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [init, setInit] = useState<boolean>(false)
  const { fetch: getLoggedIn } = useRequest<boolean>(
    useCallback(() => securityApi.loggedIn(), []),
    (res) => {
      setLoggedIn(res)
    }
  )
  const { fetch: checkInit } = useRequest<boolean | NetworkDownNoMessageResponse>(
    initialConfigApi.checkInit,
    (res) => {
      setInit(typeof res === 'boolean' ? res : res.networkDown)
    }
  )

  useEffect(() => {
    const initialConfig = async () => {
      await getLoggedIn()
      if (!init) {
        await checkInit()
      }
      setLoading(false)
    }
    initialConfig()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return loading ? (
    <Box display='flex' justifyContent='center' alignItems='center' width='100%' height='100%'>
      <CircularProgress />
    </Box>
  ) : !init ? (
    <Navigate to='/initial-config/' />
  ) : loggedIn ? (
    <Component />
  ) : (
    <Navigate to='/auth/' />
  )
}

export default PrivateRoute
